export default {
  username: 'Username',
  password: 'Password',
  firstName: 'First name',
  lastName: 'Last name',
  email: 'E-mail',
  newPassword: 'New password',
  confirmPassword: 'Confirm password',
  remixerTitle: 'Remixer title',
};
